import React, { FC, useEffect, useState } from 'react'
import { Svg_s } from "styles/app-styles"
import { ExcelExportIcon } from "images/icons/tools"
import exportService from "data/export"
import ConfirmationModal from "components/modal/confirmation-modal"
import loadingService from 'data/loading'

interface Props {
  properties?: object[],
  chartid?: string,
  template: string
}

const ExportIcon: FC<Props> = (props) => {
  const [showErrorModal, toggleErrorModal] = useState<boolean>(false);
  const [propsWithErrors, updatePropsWithErrors] = useState<object[]|null>(null);

  useEffect(() => {
    exportService.stream().subscribe(obj => {
      if (obj['propsWithErrors']) updatePropsWithErrors(obj['propsWithErrors']);
      toggleErrorModal(obj['exportConfirmVisible']);
      loadingService.toggleLoading(obj['loading'], 'export-icon');
    });
  }, []);

  function confirmAndClose():void {
    exportService.exportFileCb(props.template, props.chartid || null);
    if (showErrorModal) toggleErrorModal(false);
  }

  return (
    <div>
      <ConfirmationModal
        show={showErrorModal}
        toggleShow={toggleErrorModal}
        title={'Export Validation Warning'}
        confirmText={'Ignore'}
        confirmFunc={()=>confirmAndClose()}
        cancelFunc={()=>exportService.cancelExport()}
        message={`Be advised that if you choose to export before fixing all the input errors for the properties in this folder your exported file could be missing data.  Do you wish to ignore this warning and export anyway?`}
        confirmOnly={false}
        closeOnly={false}
      >
        { propsWithErrors && <div>
          <p>The following properties in this folder have input errors:</p>
          <ul>{ propsWithErrors.map(prop=> <li key={`error-${prop['code']}`}>{prop['code']}</li>) }</ul>
        </div> }
      </ConfirmationModal>

      <Svg_s 
        onClick={()=>props.chartid ? exportService.exportFile(props.template, null, props.chartid) : exportService.exportFile(props.template, props.properties, null)}
        src={ExcelExportIcon} 
        style={{height: '28px', display: 'flex'}} 
      />
    </div>
  )
}

export default ExportIcon